export const DragType = {
    Parcel: 'Parcel',
    Project: 'Project'
}
